package com.fabiorosati.components.sections

import androidx.compose.runtime.*
import com.fabiorosati.SubheadlineTextStyle
import com.fabiorosati.common.Language
import com.fabiorosati.common.getTranslations
import com.fabiorosati.components.widgets.ClickableImage
import com.fabiorosati.components.widgets.VerticalSpacer
import com.varabyte.kobweb.compose.css.Cursor
import com.varabyte.kobweb.compose.css.functions.url
import com.varabyte.kobweb.compose.foundation.layout.*
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.graphics.Colors
import com.varabyte.kobweb.compose.ui.modifiers.*
import com.varabyte.kobweb.silk.components.navigation.Link
import com.varabyte.kobweb.silk.components.navigation.UncoloredLinkVariant
import com.varabyte.kobweb.silk.components.text.SpanText
import com.varabyte.kobweb.silk.style.breakpoint.Breakpoint
import com.varabyte.kobweb.silk.style.breakpoint.displayIfAtLeast
import com.varabyte.kobweb.silk.style.breakpoint.displayUntil
import com.varabyte.kobweb.silk.style.toModifier
import org.jetbrains.compose.web.css.cssRem
import org.jetbrains.compose.web.css.percent
import org.jetbrains.compose.web.dom.Span


@Composable
fun NextShowsSection(
    id: String,
    title: String,
    language: Language,
    onNotifyTop: () -> Unit = {},
) {
    HomeSection(
        id = id,
        title = title,
        backgroundImage = "/valkanorr-shows.png",
        onNotifyTop = { onNotifyTop() },
    ) {
        Column(
            modifier = SubheadlineTextStyle.toModifier()
                .fillMaxWidth(),
            horizontalAlignment = Alignment.CenterHorizontally,
            verticalArrangement = Arrangement.spacedBy(0.5.cssRem)
        ) {
            Shows2026()
            VerticalSpacer(1.cssRem)
            Span {
                SpanText(language.getTranslations().nextShowsBook + " ")
                Link(
                    path = "/#contacts",
                    text = language.getTranslations().contactUs,
                    variant = UncoloredLinkVariant
                )
            }
        }
    }
}

@Composable
private fun LiveShow(
    event: String,
    date: String,
    location: String,
    link: String,
) {
    var hovering by remember { mutableStateOf(false) }
    val contentModifier = Modifier
        .onMouseOver { hovering = true  }
        .onMouseOut { hovering = false }
        .cursor(Cursor.Pointer)
        .fillMaxWidth()
        .backgroundColor(Colors.Black.copy(alpha = if(hovering) 100 else 150))
        .padding(1.1.cssRem)

    SmallLiveShow(
        modifier = contentModifier.displayUntil(Breakpoint.MD),
        event = event,
        date = date,
        location = location,
        link = link
    )

    MediumLiveShow(
        modifier = contentModifier.displayIfAtLeast(Breakpoint.MD),
        event = event,
        date = date,
        location = location,
        link = link
    )
}

@Composable
private fun SmallLiveShow(
    modifier: Modifier = Modifier,
    event: String,
    date: String,
    location: String,
    link: String,
) {
    Row(
        modifier = modifier,
        verticalAlignment = Alignment.CenterVertically
    ) {
        Column {
            SpanText(date)
            SpanText(event)
            SpanText(location)
        }
        Spacer()
        ClickableImage(
            src = "/icons/link-white.svg",
            hoverSrc = "/icons/link-primary.svg",
            description = "link icon",
            path = link
        )
    }
}

@Composable
private fun MediumLiveShow(
    modifier: Modifier = Modifier,
    event: String,
    date: String,
    location: String,
    link: String,
) {
    Row(
        modifier = modifier,
        verticalAlignment = Alignment.CenterVertically
    ) {
        Column(
            modifier = Modifier.width(25.cssRem)
        ) {
            SpanText(date)
            SpanText(event)
        }
        SpanText(location)
        Spacer()
        ClickableImage(
            src = "/icons/link-white.svg",
            hoverSrc = "/icons/link-primary.svg",
            description = "link icon",
            path = link
        )
    }
}

@Composable
private fun Shows2025() {
    LiveShow(
        event = "Insubria Festival",
        date = "25.26.27/04/2025",
        location = "Marcallo con Casone (MI), Italy",
        link = "https://www.insubriafestival.org/"
    )
    LiveShow(
        event = "Steam Party",
        date = "10.11/05/2025",
        location = "San Marino",
        link = "https://www.sanmarinocomics.com/content/steam-party-2025"
    )
    LiveShow(
        event = "Torneo di Maggio",
        date = "24.25/05/2025",
        location = "Cuorgnè (TO), Italy",
        link = "https://www.torneodimaggio.com/"
    )
    LiveShow(
        event = "Beltane Pagan Festival",
        date = "30/05/2025",
        location = "Masserano (BI), Italy",
        link = "https://beltanefestival.it/"
    )
    LiveShow(
        event = "Belgioioso Medievale",
        date = "02/06/2025",
        location = "Belgioioso (PV), Italy",
        link = "https://www.belgioiosomedievale.it/"
    )
    LiveShow(
        event = "In Nomine Matris",
        date = "13.14.15/06/2025",
        location = "Capo di Ponte (BS), Italy",
        link = "https://www.instagram.com/innomine_matris/?hl=en"
    )
    LiveShow(
        event = "Festa privata",
        date = "12/07/2025",
        location = "",
        link = ""
    )
    LiveShow(
        event = "Giorni medioevali al Castel Tasso",
        date = "18.19/07/2025",
        location = "Vipiteno (BZ), Italy",
        link = "https://www.vipiteno.com/it/attivita/citta-e-cultura/castel-tasso.html"
    )
    LiveShow(
        event = "Lughnasad, l'incontro delle tribù",
        date = "18.19/07/2025",
        location = "Golasecca (VA), Italy",
        link = "https://www.lughnasad.it/"
    )
    LiveShow(
        event = "Montelago Celtic Festival",
        date = "09/08/2025",
        location = "Serravalle di Chienti (MC), Italy",
        link = "https://www.montelagocelticfestival.it/"
    )
    LiveShow(
        event = "Druidia",
        date = "21/08/2025",
        location = "Cesenatico (FC), Italy",
        link = "https://www.druidia.it/"
    )
    LiveShow(
        event = "The Church",
        date = "22/08/2025",
        location = "Wien, Austria",
        link = "https://www.instagram.com/churchpubofficial/"
    )
    LiveShow(
        event = "Festiwal Mitologii Słowiańskiej",
        date = "23.24/08/2025",
        location = "Owidz, Poland",
        link = "https://www.instagram.com/muzeummitologiislowianskiej/"
    )
    LiveShow(
        event = "Abruzzo Irish Festival",
        date = "29/08/2025",
        location = "Notaresco (TE), Italy",
        link = "https://www.abruzzoirishfestival.it/"
    )
    LiveShow(
        event = "San Marino Comics",
        date = "30.31/08/2025",
        location = "San Marino",
        link = "https://www.sanmarinocomics.com"
    )
    LiveShow(
        event = "Axa Briga",
        date = "06.07/09/2025",
        location = "Settimo Rottaro (TO), Italy",
        link = "https://www.axabriga.it/"
    )
//            LiveShow(
//                event = "Mutina Boica",
//                date = "12 Settembre 2025",
//                location = "Modena (MO), Italy",
//                link = "https://cronoeventi.it/"
//            )
    LiveShow(
        event = "Roi de l'Oiseau",
        date = "19.20/09/2025",
        location = "Le Puy-en-Velay, France",
        link = "https://www.roideloiseau.com/"
    )
    LiveShow(
        event = "Ragnarök Viking Fest ",
        date = "28/09/2025",
        location = "Casirate d'Adda (BG), Italy",
        link = "https://linktr.ee/ragnarokfest?utm_source=linktree_profile_share&ltsid=6c8d8826-2de3-4736-a550-6a17a536f811"
    )
    LiveShow(
        event = "Capodanno Celtico",
        date = "31/10/2025",
        location = "Busto Arsizio (VA), Italy",
        link = "https://www.gensdys.it/calendario_gensdys/"
    )
    LiveShow(
        event = "Fantasylvi",
        date = "01/11/2025",
        location = "Silvi (TE), Italy",
        link = "https://www.facebook.com/profile.php?id=61580424167240"
    )
    LiveShow(
        event = "Birreria Valhalla",
        date = "20/12/2025",
        location = "Asola (MN), Italy",
        link = "https://www.birreriavalhalla.it/"
    )
}

@Composable
private fun Shows2026() {
    LiveShow(
        event = "Insubria Festival",
        date = "25.26/04/2026",
        location = "Marcallo con Casone (MI), Italy",
        link = "https://www.insubriafestival.org/"
    )
    LiveShow(
        event = "Canavese Comics",
        date = "06/06/2026",
        location = "Ivrea (TO)",
        link = "https://www.instagram.com/canavese.comics/"
    )
    LiveShow(
        event = "In Nomine Matris",
        date = "07/06/2026",
        location = "Capo di Ponte (BS), Italy",
        link = "https://www.instagram.com/innomine_matris/?hl=en"
    )
    LiveShow(
        event = "Strigarium",
        date = "12.13.14/06/2026",
        location = "Casirate d'Adda (BG), Italy",
        link = "https://www.strigarium.it/"
    )
    LiveShow(
        event = "Triskell Celtic Festival",
        date = "19/06/2026",
        location = "Trieste (TS), Italy",
        link = "https://www.triskellfestival.it/"
    )
    LiveShow(
        event = "Valhalla, Popoli del Nord",
        date = "20/06/2026",
        location = "Casalmoro (MN), Italy",
        link = "https://www.birreriavalhalla.it/"
    )
    LiveShow(
        event = "Fèstas Dau Volo Biòu",
        date = "13.14/07/2026",
        location = "Saint-Ambroix (France)",
        link = "https://www.volo-biou.fr/"
    )
    LiveShow(
        event = "Festa del Renaixement de Tortosa",
        date = "17.18.19/07/2026",
        location = "Tortosa (Spain)",
        link = "https://festadelrenaixement.org/"
    )
    LiveShow(
        event = "Sicula Ragonesia",
        date = "25/07/2026",
        location = "Randazzo (CT), Italy",
        link = "https://sicularagonensia.it/festamedievale/"
    )
    LiveShow(
        event = "La Giostra di Castello del Matese",
        date = "31/07/2026 - 01.02/08/2026",
        location = "Castello del Matese (CE), Italy",
        link = "https://www.lagiostracastellomatese.it/"
    )
    LiveShow(
        event = "Sagra Paesana di Fine Estate",
        date = "03/09/2026",
        location = "Novazzano, Switzerland",
        link = "https://www.sagrapaesana.ch/"
    )
    LiveShow(
        event = "Axa Briga",
        date = "04/09/2026",
        location = "Settimo Rottaro (TO), Italy",
        link = "https://www.axabriga.it/"
    )
    LiveShow(
        event = "Adunata Open Air",
        date = "06/09/2026",
        location = "Milano (MI), Italy",
        link = "https://www.adunata.live/"
    )
    LiveShow(
        event = "Mutina Boica",
        date = "11/09/2026",
        location = "Modena (MO), Italy",
        link = "https://cronoeventi.it/"
    )
    LiveShow(
        event = "Il Barbarossa",
        date = "18.19.20/09/2026",
        location = "Bologna (BO), Italy",
        link = "https://www.ilbarbarossa.net/"
    )
    LiveShow(
        event = "TBA",
        date = "25.26.27/09/2026",
        location = "",
        link = ""
    )
    LiveShow(
        event = "TBA",
        date = "31/10/2026 - 01/11/2026",
        location = "",
        link = ""
    )
//    LiveShow(
//        event = "Ragnarök Viking Fest ",
//        date = "25.26.27/09/2026",
//        location = "Casirate d'Adda (BG), Italy",
//        link = "https://linktr.ee/ragnarokfest?utm_source=linktree_profile_share&ltsid=6c8d8826-2de3-4736-a550-6a17a536f811"
//    )
}